import { bus } from "../core/bus";
import type { Squad } from "../ai/squad";

const UNDER_FIRE_DURATION = 1.4;

export class SquadStatusHud {
  private readonly el: HTMLElement;
  private underFireLife = 0;
  private readonly onUnderFire = (): void => {
    this.underFireLife = UNDER_FIRE_DURATION;
  };

  constructor() {
    const el = document.querySelector("[data-slot='squad']") as HTMLElement | null;
    if (!el) throw new Error("Missing HUD squad slot");
    this.el = el;
    this.el.style.lineHeight = "1.6";
    bus.on("squad:underFire", this.onUnderFire);
  }

  update(squad: Squad, dt: number): void {
    if (this.underFireLife > 0) this.underFireLife = Math.max(0, this.underFireLife - dt);
    const alive = squad.aliveCount;
    const total = squad.totalCount;
    const dots = Array.from({ length: total }, (_, i) =>
      i < alive ? "● " : "○ ",
    ).join("");
    const obj = squad.completed ? "COMPLETE" : `OBJ: ${squad.currentObjectiveLabel}`;
    const alert = this.underFireLife > 0
      ? `<br><span style="font-size:11px;color:#ff7e5f;letter-spacing:0.16em">UNDER FIRE</span>`
      : "";
    this.el.innerHTML =
      `SQUAD ${alive}/${total}<br><span style="font-size:11px">${dots}</span><br><span style="font-size:11px;opacity:0.7">${obj}</span>${alert}`;
  }

  dispose(): void {
    bus.off("squad:underFire", this.onUnderFire);
  }
}
